import Nullstack from 'nullstack';
export default function IconAntenna({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-antenna",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20 4v8"
  }), "   ", Nullstack.element("path", {
    d: "M16 4.5v7"
  }), "   ", Nullstack.element("path", {
    d: "M12 5v16"
  }), "   ", Nullstack.element("path", {
    d: "M8 5.5v5"
  }), "   ", Nullstack.element("path", {
    d: "M4 6v4"
  }), "   ", Nullstack.element("path", {
    d: "M20 8h-16"
  }), " ");
}